module.exports = __webpack_public_path__ + "img/cert13.4e30285f.png";